import { TooltipPlusOutlineIcon } from './TooltipPlusOutlineIcon';

/**
 * author: Austin Andrews
 * id CAA5F3A3-2044-48AC-94CA-04899F9459ED
 * name tooltip-plus-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tooltip-plus-outline.svg
 * tags
 * - Tooltip 
 */
export const TooltipOutlinePlusIcon = TooltipPlusOutlineIcon;
export default TooltipOutlinePlusIcon